import { isMeetingConfirmed, isMeetingPending } from 'common-data-handling';
import { identity } from 'lodash';
import { useMeetings } from '../../../../data/hooks/meeting/useMeetings';
import { useCallback } from 'react';

function useScheduleMeetings(eventId, options = {}) {
    const { filter = identity, ...otherOptions } = options,
        meetingsFilter = useCallback((meeting) => filter(meeting) && (isMeetingConfirmed(meeting) || isMeetingPending(meeting)), [filter]),
        meetings = useMeetings(eventId, { filter: meetingsFilter, ...otherOptions });

    return meetings;
}

export default useScheduleMeetings;
